import React from 'react';
import { Layout } from '@/components/layout/Layout';
import Seo from '@/components/Seo';

export default function PrivacyPage() {
  return (
    <Layout>
      <Seo
        title="Privacy Policy"
        description="Learn how yBro collects, uses, and protects your information."
        path="/privacy"
      />
      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-black font-heading text-slate-900 mb-8">
            Privacy Policy
          </h1>
          <p className="text-slate-600 font-body leading-relaxed mb-6">
            This Privacy Policy explains how yBro Limited collects, uses, and protects
            your personal information when you visit our website or contact us.
          </p>

          <div className="space-y-8 text-slate-600 font-body leading-relaxed">
            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Who we are</h2>
              <p>
                yBro Limited, 124 City Road, London, EC1V 2NX, UK. For privacy
                questions, email <a href="mailto:hello@ybro.com" className="text-ybro-primary">hello@ybro.com</a>.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Information we collect</h2>
              <p>
                We may collect contact details you submit (such as name, email, phone,
                and message), and basic technical data like device type, browser, and
                pages visited for analytics purposes.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">How we use your information</h2>
              <p>
                We use your information to respond to enquiries, provide services you
                request, improve our website, and communicate about our offerings.
                We do not sell your personal information.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Legal basis</h2>
              <p>
                We process personal data based on your consent, contractual necessity,
                or our legitimate interests in operating and improving the business.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Sharing and storage</h2>
              <p>
                We may use trusted service providers to host or process data. We take
                reasonable steps to secure your information and store it only as long
                as necessary for the purposes described.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Your rights</h2>
              <p>
                You may request access, correction, or deletion of your data. Contact
                us at <a href="mailto:hello@ybro.com" className="text-ybro-primary">hello@ybro.com</a>.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Updates</h2>
              <p>
                We may update this policy from time to time. Please check this page
                for the latest version.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
